import { Transform, Type } from 'class-transformer';
import { MatchDtoWithSlate } from './probability.dto';
import {
	ArrayNotEmpty,
	IsArray,
	IsDateString,
	IsEnum,
	IsInt,
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsString,
	IsUUID,
	Max,
	Min,
	ValidateNested,
} from 'class-validator';

export class BulkDeleteMatchesDto {
	@IsArray()
	@IsUUID('4', { each: true })
	matchIds: string[];
}

export enum MoreMatchesTab {
	LIVE_NOW = 'live_now',
	SETTLED = 'settled',
	TODAY = 'today',
	TOMORROW = 'tomorrow',
	ALL = 'all',
}

export class GetMoreMatchesQueryDto {
	@IsString()
	@IsNotEmpty()
	eventId: string;

	@IsUUID('4')
	@IsOptional()
	lobbyId?: string;

	@IsEnum(MoreMatchesTab)
	@IsOptional()
	tab?: MoreMatchesTab;

	@IsInt()
	@Min(0)
	@IsOptional()
	@Type(() => Number)
	skip?: number;

	@IsInt()
	@Min(1)
	@Max(8)
	@IsOptional()
	@Type(() => Number)
	limit?: number;

	@IsString()
	@IsOptional()
	timezone?: string;

	@IsUUID('4', { each: true })
	@IsOptional()
	@Transform(({ value }) => {
		if (Array.isArray(value)) {
			return value.flatMap((item) =>
				String(item)
					.split(',')
					.map((id) => id.trim())
					.filter(Boolean)
			);
		}

		if (typeof value === 'string') {
			return value
				.split(',')
				.map((id) => id.trim())
				.filter(Boolean);
		}

		return undefined;
	})
	excludeMatchIds?: string[];
}

export class MoreMatchesCountsDto {
	live_now: number;
	settled: number;
	today: number;
	tomorrow: number;
	all: number;
}

export class PaginatedMoreMatchesResponseDto {
	items: MatchDtoWithSlate[];
	total: number;
	counts: MoreMatchesCountsDto;
	activeTab: MoreMatchesTab | null;
}

export class latestMatchInfoDto {
	id: string;
	closing_time: Date;
	are_all_markets_settled: boolean;
}

export class CreateMatchDto {
	@IsUUID('4')
	@IsNotEmpty()
	slate_id: string;

	@IsString()
	@IsNotEmpty()
	event_id: string;

	@IsString()
	@IsNotEmpty()
	name: string;

	@IsDateString()
	opening_time: string;

	@IsDateString()
	closing_time: string;

	@IsNumber()
	@IsOptional()
	multiplier?: number;
}

export class BulkCreateMatchesDto {
	@IsArray()
	@ArrayNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => CreateMatchDto)
	items: CreateMatchDto[];
}

export class UpdateMatchDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsString()
	@IsOptional()
	name?: string;

	@IsDateString()
	@IsOptional()
	opening_time?: string;

	@IsDateString()
	@IsOptional()
	closing_time?: string;

	@IsNumber()
	@IsOptional()
	multiplier?: number;
}

export class BulkUpdateMatchItemDto {
	@IsUUID('4')
	@IsNotEmpty()
	id: string;

	@IsInt()
	@Min(1)
	@IsOptional()
	order?: number;

	@IsNumber()
	@IsOptional()
	multiplier?: number;
}

export class BulkUpdateMatchesDto {
	@IsArray()
	@ArrayNotEmpty()
	@ValidateNested({ each: true })
	@Type(() => BulkUpdateMatchItemDto)
	items: BulkUpdateMatchItemDto[];
}

export class UpdateMatchOpeningDescriptionDto {
	@IsUUID('4')
	@IsNotEmpty()
	match_id: string;

	@IsString()
	@IsNotEmpty()
	opening_description: string;
}

export class RefreshMatchResultsDto {
	@IsUUID('4')
	@IsNotEmpty()
	match_id: string;
}
export class MatchDto {
	id: string;
	event_id: string;
	slate_id: string;
	name: string;

	opening_time: Date;
	closing_time: Date;

	opening_description?: string | null;
	ext_api_id?: string | null;

	home_competitors: any;
	away_competitors: any;

	venue_name: string | null;
	venue_location: string | null;
	season_type: string | null;

	order: number;

	created_by: string;
	created_date: Date;
	updated_date: Date;
	deleted_date?: Date;

	isUserSelectMatch?: boolean;

	all_markets_settled?: boolean;

	result?: any;
}
